/*
 * COPYRIGHT (c) 2022
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import { Tab } from '@scuf/common';
import React from 'react';
import descriptors from '../../../locales/en-US/descriptors';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';

export const getTabs = (
  t: any,
  displayWidgets: string[],
  displayLable?: IAny
) => {
  const d = descriptors.energyManagement;
  const displayTitle = displayLable && displayLable[0];
  let TabArray = [];
  if (displayWidgets.includes('eui')) {
    TabArray.push(<Tab.Pane title={t(d.EUITAB)}></Tab.Pane>);
  }
  if (displayWidgets.includes('energy')) {
    const displayTitleEnergy = displayTitle?.energy;
    TabArray.push(
      <Tab.Pane
        title={displayTitleEnergy ? displayTitleEnergy : t(d.ENERGYTAB)}
      ></Tab.Pane>
    );
  }
  if (displayWidgets.includes('carbon')) {
    const displayTitleCarbon = displayTitle?.carbon;
    TabArray.push(
      <Tab.Pane
        title={displayTitleCarbon ? displayTitleCarbon : t(d.CARBONTAB)}
      ></Tab.Pane>
    );
  }

  if (displayWidgets.includes('utility')) {
    const displayTitleUtility = displayTitle?.utility;
    TabArray.push(
      <Tab.Pane
        title={displayTitleUtility ? displayTitleUtility : t(d.UTILITYCOST)}
      ></Tab.Pane>
    );
  }
  return TabArray;
};

export const getTabsDataUpload = (
  t: IAny,
  toggleFeatureScopeOne: boolean | undefined,
  getCommonHOCForDataUpload: IAny,
  activeIndex: number,
  toggleFeatureAllUpload: boolean | undefined,
  toggleFeatureScopeTwo: boolean | undefined,
  toggleFeatureGAS: boolean | undefined
) => {
  const d = descriptors.energyManagement;
  let TabArray = [];
  if (toggleFeatureAllUpload) {
    TabArray.push(
      <Tab.Pane title={t(d.ALLUPLOADS)}>
        {getCommonHOCForDataUpload(activeIndex)}
      </Tab.Pane>
    );
  }
  if (toggleFeatureScopeOne) {
    TabArray.push(
      <Tab.Pane title={t(d.STATIONARYCOMBUSTION)}>
        {getCommonHOCForDataUpload(activeIndex)}
      </Tab.Pane>
    );
    TabArray.push(
      <Tab.Pane title={t(d.REFRIGERANTS)}>
        {getCommonHOCForDataUpload(activeIndex)}
      </Tab.Pane>
    );
  }
  if (toggleFeatureScopeTwo) {
    TabArray.push(
      <Tab.Pane title={t(d.SCOPE2)}>
        {getCommonHOCForDataUpload(activeIndex)}
      </Tab.Pane>
    );
  }

  if (toggleFeatureGAS) {
    TabArray.push(
      <Tab.Pane title={t(d.METEREDGAS)}>
        {getCommonHOCForDataUpload(activeIndex)}
      </Tab.Pane>
    );
  }
  return TabArray;
};

export const getUpdatedTabsDataUpload = (
  t: IAny,
  toggleFeatureScopeOne: boolean | undefined,
  getCommonHOCForDataUpload: IAny,
  activeIndex: number,
  toggleFeatureAllUpload: boolean | undefined
) => {
  const d = descriptors.energyManagement;
  let TabArray = [];
  if (toggleFeatureAllUpload) {
    TabArray.push(
      <Tab.Pane title={t(d.ALLUPLOADS)}>
        {getCommonHOCForDataUpload(activeIndex)}
      </Tab.Pane>
    );
  }
  return TabArray;
};

export const getTabsScopeOneError = (
  t: IAny,
  toggleFeatureScopeOne: boolean | undefined,
  toggleFeatureScopeTwo: boolean | undefined,
  getCommonHOC: IAny,
  toggleFeatureGAS: boolean | undefined
) => {
  const d = descriptors.energyManagement;
  let TabArray = [];
  if (toggleFeatureScopeOne) {
    TabArray.push(
      <Tab.Pane title={t(d.STATIONARYCOMBUSTION)}>{getCommonHOC()}</Tab.Pane>
    );
    TabArray.push(
      <Tab.Pane title={t(d.REFRIGERANTS)}>{getCommonHOC()}</Tab.Pane>
    );
  }
  if (toggleFeatureScopeTwo) {
    TabArray.push(<Tab.Pane title={t(d.SCOPE2)}>{getCommonHOC()}</Tab.Pane>);
  }
  if (toggleFeatureGAS) {
    TabArray.push(
      <Tab.Pane title={t(d.METEREDGAS)}>{getCommonHOC()}</Tab.Pane>
    );
  }
  return TabArray;
};
